import { jsx as _jsx } from "react/jsx-runtime";
import Script from 'next/script';
export const GoogleAnalytics = () => {
    if (!process.env.GTAG_ID)
        return null;
    return (_jsx(Script, { id: "google-analytics", strategy: "afterInteractive", children: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
      
        gtag('config', '${process.env.GTAG_ID}');
      ` }));
};
